import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "base_info",
  "use": "base_info-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"base_info\"><g fill-rule=\"evenodd\"><path d=\"M15 12a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h12a1 1 0 011 1v10zM14 0H2C.897 0 0 .897 0 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2z\" /><path d=\"M3.4 8h2.2a.4.4 0 00.4-.4V4.4a.4.4 0 00-.4-.4H3.4a.4.4 0 00-.4.4v3.2a.4.4 0 00.4.4M8 5h5V4H8zM8 8h5V7H8zM3 11h10v-1H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id